import React from 'react';
import ItemHeader from '../atoms/ItemHeader';
import * as S from './style';
import usePrimeiraMao from 'hooks/usePrimeiraMao';

const EvaluationPrimeiraMao = () => {
  const { uriSell } = usePrimeiraMao();

  return (
    <div>
      <ItemHeader>Avaliação Primeira Mão</ItemHeader>
      <S.Iframe src={uriSell} allow="geolocation *" />
    </div>
  );
};

export default EvaluationPrimeiraMao;
